export const buildLookupMaps = (relationships = []) =>
  Object.fromEntries(
    relationships.map((relationship) => [
      relationship.field,
      Object.fromEntries(
        (relationship.options ?? []).map((option) => [
          option.key,
          option,
        ])
      ),
    ])
  );

export const getColumnValue = (
  row,
  column,
  lookupMaps = {}
) => {
  const fields = row?.fields ?? {};

  if (column.type === "lookup") {
    const relatedId = fields[column.field];
    const option = lookupMaps[column.field]?.[relatedId];

    return option?.label ?? "";
  }

  return fields[column.field] ?? "";
};

export const buildLookupColumns = (relationship) => {
  const baseColumns = [
    {
      field: "label",
      label: relationship.label,
      type: "text",
    },
  ];
  
  if (relationship.targetColumns?.length) {
    const targetColumns = relationship.targetColumns
      .filter((column) => column.visible !== false)
      .map((column) => ({
        field: column.field,
        label: column.label ?? column.field,
        type: column.type ?? "text",
      }))
      .filter((column) => column.field !== relationship.targetLabel);

    return [...baseColumns, ...targetColumns];
  }

  const firstOption = relationship.options?.[0];

  if (!firstOption?.fields) {
    return baseColumns;
  }

  const fieldColumns = Object.keys(firstOption.fields).map(
    (field) => ({
      field,
      label: field,
      type:
        typeof firstOption.fields[field] === "boolean"
          ? "boolean"
          : "text",
    })
  );

  return [...baseColumns, ...fieldColumns];
};

export const getLookupOptionValue = (option, column) => {
  if (column.field === "label") {
    return option?.label ?? "";
  }

  return option?.fields?.[column.field] ?? "";
};

export const filterLookupOptions = (
  relationship,
  searchValue
) => {
  const search = String(searchValue ?? "")
    .trim()
    .toLowerCase();

  const options = relationship.options ?? [];

  if (!search) {
    return options;
  }

  return options.filter((option) => {
    const labelMatches = String(option.label ?? "")
      .toLowerCase()
      .includes(search);

    const fieldMatches = Object.values(
      option.fields ?? {}
    ).some((value) =>
      String(value ?? "").toLowerCase().includes(search)
    );

    return labelMatches || fieldMatches;
  });
};